import React, { useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const FAQItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="border-b border-gray-200">
            <button
                className="w-full py-6 flex justify-between items-center text-left focus:outline-none hover:text-orange-600 transition-colors"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="text-lg font-semibold text-gray-900">{question}</span>
                <svg
                    className={`w-5 h-5 text-gray-400 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                    fill="none" stroke="currentColor" viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
            </button>
            {isOpen && (
                <div className="pb-6 text-gray-600 text-base leading-relaxed animate-fade-in-down">
                    {answer}
                </div>
            )}
        </div>
    );
};

const FAQ = () => {
    const { getFullTranslation } = useLanguage();
    const faq = getFullTranslation('faq');

    return (
        <div id="faq" className="max-w-7xl mx-auto px-6 py-24 flex flex-col md:flex-row gap-16">
            <div className="w-full md:w-1/3">
                <h2 className="text-3xl font-extrabold text-gray-900 mb-4">{faq.title}</h2>
                <p className="text-gray-500 mb-2">{faq.subtitle}</p>
                <p className="text-gray-500">{faq.contact}</p>
            </div>

            <div className="w-full md:w-2/3">
                <div className="border-t border-gray-200">
                    {faq.questions && faq.questions.map((faqItem, index) => (
                        <FAQItem key={index} question={faqItem.question} answer={faqItem.answer} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQ;
